/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { fcmControllerUpsertFcmToken } from '../fn/fcm/fcm-controller-upsert-fcm-token';
import { FcmControllerUpsertFcmToken$Params } from '../fn/fcm/fcm-controller-upsert-fcm-token';

@Injectable({ providedIn: 'root' })
export class FcmService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `fcmControllerUpsertFcmToken()` */
  static readonly FcmControllerUpsertFcmTokenPath = '/api/fcm';

  /**
   * FCM upsert.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fcmControllerUpsertFcmToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  fcmControllerUpsertFcmToken$Response(params: FcmControllerUpsertFcmToken$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return fcmControllerUpsertFcmToken(this.http, this.rootUrl, params, context);
  }

  /**
   * FCM upsert.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fcmControllerUpsertFcmToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fcmControllerUpsertFcmToken(params: FcmControllerUpsertFcmToken$Params, context?: HttpContext): Observable<void> {
    return this.fcmControllerUpsertFcmToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
